export default __webpack_public_path__ + "static/media/microsoft.33e43058.jpg";